import { Box, Grid } from "@mui/material";
import RentPaymentPopup from "../../components/Fleet/RentPaymentPopup/RentPaymentPopup";
import RentPaymentTable from "../../components/Fleet/RentPaymentTable/RentPaymentTable";

const RentPaymentPage = () => {
  return (
    <Box className="driver-page">
      <Grid container spacing={1} alignItems="center" justifyContent="center">
        <Grid
          item
          xs={12}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <Box
            sx={{
              flexWrap: { xs: "wrap", lg: "nowrap" },
              flex: 1,
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Grid
              container
              spacing={1}
              justifyContent="center"
              sx={{ maxWidth: "800px" }}
            >
              <Grid item>
                <RentPaymentPopup />
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <RentPaymentTable />
        </Grid>
      </Grid>
    </Box>
  );
};

export default RentPaymentPage;
